import { useMutation, useQueryClient } from '@tanstack/react-query'

import { showErrorToast } from 'common/api/helpers'
import { successToast } from 'common/components/toastNotification'
import { useAppSelector } from 'common/hooks/redux'

import { brandVoiceKeys } from '../../../brandVoice/api/queryKeys'
import type { AdvancedLanguageRuleBody } from '../api'
import { editAdvancedLanguageRule } from '../api'

const useEditAdvancedLanguageRuleMutation = () => {
  const queryClient = useQueryClient()

  const accountId = useAppSelector((state) => state.authStates.accountId)
  const brandVoiceId = useAppSelector(
    (state) => state.styleGuide.selectedBrandVoiceId
  )

  return useMutation({
    mutationFn: ({
      ruleId,
      data,
    }: {
      ruleId: string
      data: AdvancedLanguageRuleBody
    }) => {
      if (!brandVoiceId) {
        return Promise.reject('Brand Voice is missing')
      }

      return editAdvancedLanguageRule({
        brandVoiceId,
        accountId,
        ruleId,
        data,
      })
    },
    onSuccess: () => {
      successToast('Instruction successfully edited')

      queryClient.invalidateQueries({
        queryKey: brandVoiceKeys.details(accountId, brandVoiceId!),
      })
    },
    onError: (error) => {
      showErrorToast(error)
    },
  })
}

export default useEditAdvancedLanguageRuleMutation
